import React from "react";
import { CheckoutForm } from "../../components/CheckoutForm";
import { ReactController } from "../react_controller";

export class CheckoutFormController extends ReactController {
  connect() {
    this.root.render(<CheckoutForm {...this.propsValue} />);
  }
}
